<template>
  <div class="home">
    <Hello @more="showMoreSections = true"/>
    <div v-if="showMoreSections">
      <div class="bg-gray-light">
        <AboutMe/>
        <Skills :showCards="showCards"/>
      </div>
      <div class="">
        <section class="hidden-section" id="experience" ref="experience">
            <Carreer/>
        </section>
        <section class="hidden-section" id="projects" ref="projects">
          <Projects :showProjectCards="showProjects"/>
        </section>
      </div>
      <Contact/>
      <Communities :showCards="showComCards"/>
      <Footer/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Hello from '@/components/Hello.vue'
import AboutMe from '@/components/AboutMe.vue'
import Skills from '@/components/Skills.vue'
import Carreer from '@/components/Carreer.vue'
import Projects from '@/components/Projects.vue'
import Contact from '@/components/Contact.vue'
import Communities from '@/components/Communities.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',
  components: {
    Hello,
    AboutMe,
    Skills,
    Carreer,
    Projects,
    Contact,
    Communities,
    Footer
  },
  data() {
    return {
      showMoreSections: false,
      showCards: false,
      showExpContent: false,
      showProjects: false,
      showComCards: false,
    }
  },
  created() {
    this.$root.$on('bv::scrollspy::activate', this.onActivate);
    this.$root.$on('showMoreSections', this.showMore)
  },
  methods:{
    onActivate(target){
      console.log('Received event: "bv::scrollspy::activate" for target ', target)
      if(target === '#about' || target === '#skills'){
        this.showCards = true;
      }
      else if(target === '#experience' || target === '#projects'){
        this.showExpContent = true;
        this.showProjects = true;
      }else if(target === '#contact'){
        this.showExpContent = true;
        this.showProjects = true;
        this.showCards = true;
        this.showComCards = true;
      }
      else if(target === '#communities'){
        this.showExpContent = true;
        this.showProjects = true;
        this.showComCards = true;
      }
    },
    showMore(){
      this.showMoreSections = true;
    }
  }
}
</script>

